export default __webpack_public_path__ + "static/media/rtx.7d35ad13.png";